<template>
  <div id="app">
    <el-container>
      <!-- 悬浮在页面两侧，展示logo 和联系方式 -->
      <FixedNotice v-show="!isHome"></FixedNotice>
      <el-header :class="{ 'home-header': isHome }">
        <router-link class="logo" to="/">
          <img src="./assets/img/hxy.png" alt />
          <h3>北京华欣焱科技有限公司</h3>
        </router-link>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/news">新闻资讯</el-menu-item>
          <el-menu-item index="/product">产品中心</el-menu-item>
          <!-- <el-menu-item index="/case">经典案例</el-menu-item> -->
          <el-menu-item index="/goin">走进华欣焱</el-menu-item>
          <el-menu-item index="/files">资料下载</el-menu-item>
          <el-menu-item index="/jobs">职位招聘</el-menu-item>
          <!-- <el-menu-item index="/download">下载APP</el-menu-item> -->
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="!isHome">
        <div class="footer-content">
          <div class="footer-brand">
            <div class="footer-logo">
              <img src="./assets/img/hxy.png" alt />
              <strong>北京华欣焱科技有限公司</strong>
            </div>
            <div class="footer-contact">
              <span><i class="el-icon-message"></i>350372122@qq.com</span>
              <span><i class="el-icon-phone-outline"></i>010-89216288</span>
              <span><i class="el-icon-phone-outline"></i>13811134296</span>
              <span><i class="el-icon-location-outline"></i>北京市大兴区临空经济开发区</span>
            </div>
          </div>
          <ul class="content-nav">
            <li>
              <p>走进华欣焱</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              <span>合作伙伴</span>
            </li>
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <li>
              <p>产品中心</p>
              <span>介绍视频</span>
              <span>管理模式</span>
              <span>平台目标</span>
              <span>功能模块</span>
            </li>
          </ul>
          <div class="footer-map" aria-label="查看公司地图大图">
            <el-image
              class="footer-map-image"
              :src="mapImage"
              :preview-src-list="[mapImage]"
              fit="contain"
              alt="公司地图"
            />
            <span>点击查看</span>
          </div>
        </div>
        <div class="copyright">
          <span>2026@华欣焱版权所有</span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import FixedNotice from './components/FixedNotice.vue';
import mapImage from "./assets/img/map.png";
export default {
  data() {
    return {
      router: true,
      defaultActive: this.resolveActivePath(this.$route.path),
      mapImage
    };
  },
  components: {
    FixedNotice
  },
  computed: {
    isHome() {
      return this.$route.path === "/";
    }
  },
  watch: {
    "$route.path"(path) {
      this.defaultActive = this.resolveActivePath(path);
    }
  },
  methods: {
    resolveActivePath(path) {
      if (path.indexOf("/newsdetails") === 0) return "/news";
      if (path.indexOf("/productdetails") === 0) return "/product";
      if (path.indexOf("/casedetails") === 0) return "/case";
      return path;
    },
    handleSelect(key) {
      this.defaultActive = key;
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  min-height: 100%;
  font-family: "Helvetica Neue", "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #142235;
  background: #f4f7fb;
}

#app > .el-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.el-header {
  position: sticky;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 68px;
  padding: 0 calc((100% - 1240px) / 2);
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.94);
  border-bottom: 1px solid rgba(20, 34, 53, 0.07);
  box-shadow: 0 10px 28px rgba(20, 34, 53, 0.05);
  backdrop-filter: blur(10px);

  .logo {
    min-width: 286px;
    min-height: 68px;
    padding: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;

    img {
      width: auto;
      height: 38px;
      flex: 0 0 auto;
    }

    h3 {
      height: 100%;
      display: flex;
      align-items: center;
      color: #13243a;
      font-size: 17px;
      font-weight: 700;
      letter-spacing: 0;
      white-space: nowrap;
    }
  }

  .el-menu.el-menu--horizontal {
    height: 68px;
    border-bottom: 0;
    background: transparent;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .el-menu--horizontal > .el-menu-item {
    position: relative;
    height: 38px;
    line-height: 38px;
    margin: 0;
    padding: 0 14px;
    box-sizing: border-box;
    border-radius: 999px;
    color: #24364d;
    font-size: 14px;
    font-weight: 500;
    border-bottom: 0;
    overflow: hidden;
    transition: color 0.22s ease, background 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
  }

  .el-menu--horizontal > .el-menu-item:hover,
  .el-menu--horizontal > .el-menu-item:focus {
    color: #156da8;
    background: rgba(21, 109, 168, 0.08);
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    color: #075b94;
    border: 1px solid rgba(44, 172, 226, 0.5);
    background: linear-gradient(180deg, rgba(235, 249, 255, 0.96), rgba(213, 240, 255, 0.72));
    box-shadow: 0 10px 24px rgba(21, 109, 168, 0.16), inset 0 0 16px rgba(95, 204, 255, 0.22);
    font-weight: 700;
  }

  .el-menu--horizontal > .el-menu-item.is-active::after {
    content: "";
    position: absolute;
    left: 16px;
    right: 16px;
    bottom: 5px;
    height: 2px;
    border-radius: 999px;
    background: linear-gradient(90deg, transparent, #2cace2, transparent);
    box-shadow: 0 0 10px rgba(44, 172, 226, 0.8);
  }
}

.el-header.home-header {
  box-shadow: 0 8px 24px rgba(20, 34, 53, 0.04);
}

.el-main {
  flex: 1 0 auto;
  padding: 0 !important;
}

.footer {
  flex: 0 0 auto;
  width: 100%;
  min-height: 252px;
  overflow: hidden;
  background: #0b2238;
  border-top: 1px solid rgba(44, 172, 226, 0.22);

  &-content {
    width: min(1240px, 92%);
    margin: 0 auto;
    padding: 34px 0 30px;
    display: grid;
    grid-template-columns: minmax(280px, 1.05fr) minmax(360px, 1.4fr) 156px;
    gap: 36px;
    align-items: start;
  }

  .footer-brand {
    min-width: 0;
  }

  .footer-logo {
    display: flex;
    align-items: center;
    gap: 12px;

    img {
      width: 42px;
      height: 42px;
      object-fit: contain;
    }

    strong {
      color: #fff;
      font-size: 18px;
      line-height: 1.4;
      font-weight: 700;
    }
  }

  .footer-contact {
    margin-top: 18px;
    display: grid;
    gap: 10px;

    span {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      color: rgba(255, 255, 255, 0.76);
      font-size: 14px;
      line-height: 1.55;
    }

    i {
      margin-top: 3px;
      color: #62c7f5;
      font-size: 15px;
    }
  }

    .content-nav {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 28px;

      li {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        list-style: none;

        p {
          position: relative;
          margin-bottom: 14px;
          padding-bottom: 12px;
          font-weight: 600;
          color: #fff;
          font-size: 16px;
        }

        p::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 28px;
          height: 2px;
          border-radius: 999px;
          background: #2cace2;
          box-shadow: 0 0 10px rgba(44, 172, 226, 0.7);
        }

        span {
          color: rgba(255, 255, 255, 0.66);
          font-size: 14px;
          font-weight: 300;
          line-height: 1.8;
        }
      }
    }

  .footer-map {
    width: 156px;
    height: 156px;
    padding: 8px;
    box-sizing: border-box;
    position: relative;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 8px;
    display: block;
    background: rgba(255, 255, 255, 0.06);
    cursor: zoom-in;
    overflow: hidden;
    transition: transform 0.22s ease, border-color 0.22s ease, background 0.22s ease, box-shadow 0.22s ease;

    &:hover,
    &:focus {
      transform: translateY(-3px);
      border-color: rgba(98, 199, 245, 0.56);
      background: rgba(255, 255, 255, 0.1);
      box-shadow: 0 14px 34px rgba(0, 0, 0, 0.18);
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid #62c7f5;
      outline-offset: 3px;
    }

    .footer-map-image,
    .footer-map-image img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    span {
      position: absolute;
      left: 8px;
      right: 8px;
      bottom: 8px;
      min-height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(7, 20, 33, 0.72);
      color: #fff;
      font-size: 12px;
      font-weight: 700;
      opacity: 0;
      transform: translateY(8px);
      transition: opacity 0.2s ease, transform 0.2s ease;
    }

    &:hover span,
    &:focus span {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .copyright {
    min-height: 40px;
    background: rgba(0, 0, 0, 0.22);
    text-align: center;

    span {
      color: rgba(255, 255, 255, 0.72);
      line-height: 40px;
      font-size: 13px;
    }
  }
}

.el-image-viewer__wrapper {
  z-index: 3000 !important;
}

.el-image-viewer__canvas img {
  background: #ffffff;
  border-radius: 6px;
}

@media (max-width: 1280px) {
  .el-header {
    padding: 0 24px;
  }
}

@media (max-width: 1100px) {
  .el-header {
    flex-wrap: wrap;
    height: auto !important;
    padding-top: 6px;

    .logo {
      min-width: auto;
      width: 100%;
      justify-content: center;
      min-height: 50px;
    }

    .el-menu-demo {
      width: 100%;
      display: flex;
      justify-content: center;
      overflow-x: auto;
    }

    .el-menu--horizontal > .el-menu-item {
      flex: 0 0 auto;
    }
  }
}

@media (max-width: 760px) {
  .el-header {
    padding-left: 12px;
    padding-right: 12px;

    .logo h3 {
      font-size: 15px;
    }

    .logo img {
      height: 34px;
    }

    .el-menu.el-menu--horizontal {
      height: 52px;
      justify-content: flex-start;
    }
  }

  .footer-content {
    grid-template-columns: 1fr;

    .content-nav {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .footer-map {
      justify-self: start;
    }
  }

}

@media (max-width: 520px) {
  .footer {
    .content-nav {
      grid-template-columns: 1fr;
    }

    .footer-logo {
      align-items: flex-start;
    }
  }
}
</style>
